import { FunctionalComponent } from "preact";

import "./style.css";

export const Highlight: FunctionalComponent = ({ children }) => {
  return <span className="text-highlight">{children}</span>;
};
